import moment from "moment";
import { TCalendarType } from "../../components/commons/ono-calendar-v2/calendar_types";

export const getReportFileName = ({
  reportName,
  reportType,
  fromDate,
  toDate,
}: {
  reportName: string;
  reportType: TCalendarType;
  fromDate: string | Date;
  toDate?: string | Date;
}) => {
  switch (reportType) {
    case "DAILY":
      return `${reportName} Report - ${moment(fromDate).format(
        "DD-MMM-YYYY"
      )}.xlsx`;

    case "WEEKLY":
      return `${reportName} Report - ${moment(fromDate).format(
        "DD-MMM-YYYY"
      )} to ${moment(toDate).format("DD-MMM-YYYY")}.xlsx`;

    case "MONTHLY":
      return `${reportName} Report - ${moment(fromDate).format(
        "MMM-YYYY"
      )}.xlsx`;

    case "YEARLY":
      return `${reportName} Report - ${moment(fromDate).format("YYYY")}.xlsx`;

    case "CUSTOM":
      return `${reportName} Report - ${moment(fromDate).format(
        "DD-MMM-YYYY"
      )} to ${moment(toDate).format("DD-MMM-YYYY")}.xlsx`;

    default:
      return `${reportName} Report.xlsx`;
  }
};
